export default __webpack_public_path__ + "static/media/protocolo de siniestro.6e1a8a82.pdf";